import React from 'react'
import { Paper, Box, Typography, Button } from '@material-ui/core'
import useSnackbar from 'hooks/useSnackbar'

import { Container, ContentHeader } from 'components'
import agendamentoImg from 'images/agendamento.png'
import { KeyboardDatePicker } from '@material-ui/pickers'
import ModalSuccess from 'components/ModalSuccess'

import useForm from 'react-hook-form'
import { useParams, useHistory } from 'react-router-dom'
import moment from 'moment'
import schemas from './schemas'
import * as service from 'service'
import useFetch from 'hooks/useFetch'
import { routes } from 'routes'
import { reverse } from 'named-urls'

const Suspend = () => {
  const snackbar = useSnackbar()
  const params = useParams()
  const history = useHistory()
  const contractId = params.contractId
  const [open, setOpen] = React.useState(false)
  const [invalidDate, setInvalidDate] = React.useState('')
  const [loadingForm, setLoadingForm] = React.useState(false)

  const { response } = useFetch(service.recurrence.contractSchedules.list, {
    contractId,
    executed: false,
    type: 2,
  })

  const { response: responseContract } = useFetch(
    service.recurrence.contracts.get,
    {
      contractId,
    },
  )

  const { handleSubmit, register, watch, setValue } = useForm({
    validationSchema: schemas.contractSuspend,
  })

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    history.push(
      reverse(routes.contracts.show, {
        contractId,
      }),
    )
    setOpen(false)
  }

  const onSubmit = async dataForm => {
    setLoadingForm(true)
    const date = dataForm.reactivationFieldDate
      ? moment(dataForm.reactivationFieldDate).format('DD/MM/YYYY')
      : ''
    try {
      if (responseContract?.data.contract.status === 'paused') {
        if (response?.data.schedules) {
          await service.recurrence.contractSchedules.update({
            contractId,
            scheduleId: response.data.schedules[0].id,
            date,
          })
        } else {
          await service.recurrence.contractSchedules.scheduling({
            contractId,
            date,
          })
        }
      } else {
        await service.recurrence.contractSchedules.pause({
          contractId,
          returningDate: date,
        })
      }
      handleOpen()
    } catch {
      snackbar.open({
        message: 'Falha ao suspender o contrato!',
        variant: 'error',
      })
    } finally {
      setLoadingForm(false)
    }
  }

  const handleChange = e => {
    setValue(
      'reactivationFieldDate',
      e
        ? moment(e)
            .utc(false)
            .format()
        : responseContract?.data.contract.status === 'active'
        ? null
        : 'Data invalida',
    )
  }

  const values = watch()

  React.useEffect(() => {
    if (!response) {
      return
    }
    register({ name: 'reactivationFieldDate' })
    if (response?.data?.schedules) {
      setValue('reactivationFieldDate', response.data.schedules[0].createIn)
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [register, response])

  return (
    <Container>
      <ContentHeader title="Suspender assinatura" />
      <Paper>
        <Box p={3}>
          <Box
            display="flex"
            flexGrow={1}
            flexDirection={{
              xs: 'column',
              sm: 'row-reverse',
            }}
          >
            <Box
              display="flex"
              flex={1}
              flexDirection="row"
              justifyContent="center"
              alignItems="flex-start"
              mt={-4}
            >
              <img alt="Agendamento" src={agendamentoImg} width="70%" />
            </Box>
            <Box
              display="flex"
              flex={1}
              flexDirection="row"
              alignItems="flex-start"
            >
              <Box mt={2}>
                <Typography variant="h4" color="textSecondary">
                  Informe a data para reativação da assinatura
                </Typography>
                <Box mt={{ xs: 1, sm: 5 }}>
                  <Typography variant="body1" color="textSecondary">
                    A cobrança será automaticamente reativada na data informada.
                  </Typography>
                  {responseContract?.data.contract.status === 'active' && (
                    <Typography variant="body1" color="textSecondary">
                      Caso não seja informada uma data para reativação, a
                      assinatura permanecerá suspensa por tempo indeterminado.
                    </Typography>
                  )}
                </Box>
                <form
                  id="change-schedule-date-form"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Box mt={{ xs: 4, sm: 2 }} maxWidth={300}>
                    <KeyboardDatePicker
                      margin="dense"
                      variant="outlined"
                      placeholder="Data para reativação da assinatura"
                      format="dd/MM/yyyy"
                      name="reactivationFieldDate"
                      invalidDateMessage="Data invalida"
                      minDateMessage="A data não deve ser anterior ou igual a data de hoje"
                      maxDateMessage="A data não deve ser muito distante"
                      minDate={moment().add(1, 'days')}
                      onError={e => setInvalidDate(e)}
                      fullWidth
                      onChange={e => handleChange(e)}
                      value={values.reactivationFieldDate || null}
                    ></KeyboardDatePicker>
                  </Box>
                </form>
              </Box>
            </Box>
          </Box>
          {!responseContract?.data.contract.status === 'active' && (
            <Box mt={{ xs: 2, sm: 8 }} />
          )}
          {responseContract?.data.contract.status === 'active' && (
            <Box mt={{ xs: 5, sm: 2, md: 0 }}>
              <Typography variant="h5" color="textSecondary">
                Importante:
              </Typography>
              <Box mt={4}>
                <Typography variant="body2" color="textSecondary">
                  - A cobrança será suspensa imediatamente após a confirmação
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  - O assinante receberá um e-mail no momento da suspensão e no
                  dia da reativação
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  - A qualquer momento será possivel reativar a assinatura, bem
                  como agendar uma nova data para a reativação
                </Typography>
              </Box>
            </Box>
          )}
          <ModalSuccess open={open} onClose={handleClose}>
            {responseContract?.data.contract.status === 'active'
              ? 'Assinatura suspensa'
              : 'Reativação agendada'}
          </ModalSuccess>
          <Box mt={{ xs: 7, sm: 5 }} maxWidth={{ xs: 'auto', sm: 300 }}>
            <Button
              variant="contained"
              color="primary"
              form="change-schedule-date-form"
              type="submit"
              fullWidth
              disabled={
                loadingForm ||
                (responseContract?.data.contract.status === 'active'
                  ? !!invalidDate
                  : !values.reactivationFieldDate || !!invalidDate)
              }
            >
              {responseContract?.data.contract.status === 'active'
                ? 'Confirmar suspensão'
                : 'Agendar reativação'}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  )
}

export default Suspend
